export default __webpack_public_path__ + "static/media/Me3.e7e1cfcd.png";